import http from "./http-common";

const getAll = () => {
    return http.get("/jyu");
};

const getAllKbn = () => {
    return http.get("/const/kbn");
};

const getKubunmap = () => {
    return http.get("/const/kubunmap", { withCredentials: true });
};

const getKubunmaplist = () => {
    return http.get("/const/kubunlist", { withCredentials: true });
};

const getAllMessage = () => {
    return http.get("/const/message");
};

const getMessagemap = () => {
    return http.get("/const/messagemap", { withCredentials: true });
};

const get = id => {
    return http.get(`/jyu/${id}`);
};

const create = data => {
    return http.post("/jyu", data);
};

const update = (id, data) => {
    return http.put(`/jyu/${id}`, data);
};

const remove = id => {
    return http.delete(`/jyu/${id}`);
};

const removeAll = () => {
    return http.delete(`/jyu`);
};

const findById = id => {
    return http.get(`/jyu/${id}`);
};

const logout = () => {
    return http.post(`/logout`, { withCredentials: true });
};

const checkSession = () => {
    return http.get('/login/check', { withCredentials: true });
}

const getUser = () => {
    return http.get('/login/getuser', { withCredentials: true });
}

const getAllShohinMst = () => {
    return http.get(`/mst/shohin`);
};

const getAllTokuiMst = () => {
    return http.get(`/mst/tokui`);
};

const getAnnouncement = () => {
    return http.get('/gy-ctrl/getAnnouncement');
}

const getShin = (tksakicd, choaiskicd) => {
    return http.get(`/gy-ctrl/selectShin`, {
        params: {
            tksakicd: tksakicd,
            choaiskicd: choaiskicd
        },
        withCredentials: true
    });
}

const getTniList = () => {
    return http.get("/gy-ctrl/tnilist");
}



const pocs = {
    getAll,
    get,
    create,
    update,
    remove,
    removeAll,
    findById,
    logout,
    checkSession,
    getUser,
    getAllKbn,
    getKubunmaplist,
    getKubunmap,
    getAllMessage,
    getMessagemap,
    getAllShohinMst,
    getAllTokuiMst,
    getAnnouncement,
    getShin,
    getTniList
};

export default pocs;
